import { render, staticRenderFns } from "./CustomPageIcon.vue?vue&type=template&id=4887ebe9&scoped=true&"
import script from "./CustomPageIcon.vue?vue&type=script&lang=js&"
export * from "./CustomPageIcon.vue?vue&type=script&lang=js&"
import style0 from "./CustomPageIcon.vue?vue&type=style&index=0&id=4887ebe9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4887ebe9",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4887ebe9')) {
      api.createRecord('4887ebe9', component.options)
    } else {
      api.reload('4887ebe9', component.options)
    }
    module.hot.accept("./CustomPageIcon.vue?vue&type=template&id=4887ebe9&scoped=true&", function () {
      api.rerender('4887ebe9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomPageIcon.vue"
export default component.exports